<template>
  <d-container fluid class="main-content-container p-4">
<!--    <d-modal v-if="modalVisible" size="lg" @close="onModalClose">-->
<!--      <d-modal-header>-->
<!--        <d-modal-title>Détails du virement</d-modal-title>-->
<!--      </d-modal-header>-->
<!--      <d-modal-body>-->
<!--        <d-form-row>-->
<!--          <d-col class="pr-3 border-right">-->
<!--            <div class="text-center mb-3">-->
<!--              <d-badge outline pill :theme="badge">{{ status_fr }}</d-badge>-->
<!--            </div>-->
<!--            <c-input :disabled="!is_editable" container-class="mb-0" type="select"-->
<!--                     label="Changer le statut du virement ?" :options="status_options"-->
<!--                     v-model="status" :state="status_state">-->
<!--              <template slot="first">-->
<!--                <option :value="null">Sélectionnez un statut</option>-->
<!--              </template>-->
<!--              Veuillez sélectionner un statut-->
<!--            </c-input>-->
<!--            <d-form-checkbox v-if="status" v-model="update_balance" class="mt-1">-->
<!--              Mettre à jour les soldes-->
<!--            </d-form-checkbox>-->
<!--            <c-input type="textarea" container-class="mb-3 mt-3" label="Message" v-model="message"-->
<!--                     :state="message_state" :disabled="!status">-->
<!--              Veuillez saisir un message-->
<!--            </c-input>-->
<!--            <b-form-group v-if="!status">-->
<!--              <label class="font-weight-bold mb-0">Pièce jointe</label>-->
<!--              <d-input-group>-->
<!--                <d-input-group-addon class="flex-fill" prepend>-->
<!--                  <c-input class="flex-fill" :value="attachment" disabled/>-->
<!--                </d-input-group-addon>-->
<!--                <d-input-group-addon append>-->
<!--                  <d-link class="btn btn-info" :href="attachment" target="_blank" :disabled="!has_attachment">-->
<!--                    <i class="fa fa-external-link-alt mr-1"></i> Ouvrir-->
<!--                  </d-link>-->
<!--                </d-input-group-addon>-->
<!--              </d-input-group>-->
<!--            </b-form-group>-->
<!--            <c-input v-else type="file" container-class="mb-3" label="Pièce jointe" v-model="attachment_file"/>-->
<!--            <c-input type="textarea" container-class="mb-3" label="Motif" :value="reason" disabled/>-->
<!--            <c-input type="datetime" container-class="mb-3" label="Initiée le" :value="created_at" disabled/>-->
<!--            <c-input type="datetime" container-class="mb-3" label="Dernière modification" :value="updated_at" disabled/>-->
<!--          </d-col>-->
<!--          <d-col class="ml-2">-->
<!--            <c-input type="price" currency="XAF" container-class="mb-3" label="Montant" :value="amount" disabled/>-->
<!--            <c-input type="price" currency="XAF" container-class="mb-3" label="Frais" :value="fees" disabled/>-->
<!--            <c-input type="price" currency="XAF" container-class="mb-3" label="Gain" :value="income" disabled/>-->
<!--            <c-input container-class="mb-3" label="Banque" :value="bank" disabled/>-->
<!--            <c-input container-class="mb-3" label="Bénéficiare" :value="recipient" disabled/>-->
<!--            <c-input container-class="mb-3" label="IBAN" :value="recipient_account" disabled/>-->
<!--            <b-form-group>-->
<!--              <label class="font-weight-bold mb-0">Fichier RIB</label>-->
<!--              <d-input-group>-->
<!--                <d-input-group-addon class="flex-fill" prepend>-->
<!--                  <c-input class="flex-fill" :value="rib_filename" disabled/>-->
<!--                </d-input-group-addon>-->
<!--                <d-input-group-addon append>-->
<!--                  <d-link class="btn btn-info" :href="rib_file" target="_blank">-->
<!--                    <i class="fa fa-external-link-alt mr-1"></i> Ouvrir-->
<!--                  </d-link>-->
<!--                </d-input-group-addon>-->
<!--              </d-input-group>-->
<!--            </b-form-group>-->
<!--          </d-col>-->
<!--        </d-form-row>-->
<!--      </d-modal-body>-->
<!--      <d-modal-footer class="justify-content-center">-->
<!--        <c-button-spinner v-if="is_editable" class="mr-2" variant="danger" :fetching="fetchingFormSubmit"-->
<!--                          @click="onFormSubmit">-->
<!--          <template slot="icon">-->
<!--            <i class="fa fa-exclamation-triangle"></i>-->
<!--          </template>-->
<!--          Changer le statut-->
<!--        </c-button-spinner>-->
<!--        <b-button variant="secondary" class="ml-2" @click="onModalClose">-->
<!--          <i class="fa fa-times"></i> Fermer-->
<!--        </b-button>-->
<!--      </d-modal-footer>-->
<!--    </d-modal>-->

<!--    <div>-->
<!--      &lt;!&ndash; COLLAPSE&ndash;&gt;-->
<!--      <b-button v-b-toggle.collapse-2 class="m-1 greenbutton">-->
<!--        <i class="fas fa-filter mr-2 "></i> Recherche avancée-->
<!--      </b-button>-->

<!--      &lt;!&ndash; Element to collapse &ndash;&gt;-->
<!--      <b-collapse id="collapse-2" class="mb-4">-->
<!--        <d-card class="card-small">-->
<!--          <d-card-body class="px-4 pb-0">-->
<!--            <b-row>-->
<!--              <d-input-group class="justify-content-center">-->
<!--                <c-input label="Du" type="date" class="mr-5" v-model="startDate"/>-->
<!--                <c-input label="Au" type="date" class="mr-5" v-model="endDate"/>-->
<!--                <c-input label="Mot clé de recherche" class="mr-5" placeholder="Rechercher..." v-model="search"/>-->
<!--                <c-input type="select" label="Rechercher par statut" class="mr-5" :options="status_options"-->
<!--                         v-model="searchStatus">-->
<!--                  <template slot="first">-->
<!--                    <option :value="null">Sélectionnez un statut</option>-->
<!--                  </template>-->
<!--                </c-input>-->
<!--              </d-input-group>-->
<!--            </b-row>-->
<!--            <b-row class="justify-content-center">-->
<!--              <c-button-spinner class="inline-btn ml-1 mb-3" variant="primary" :fetching="fetchingSearch"-->
<!--                                @click="onSearchSubmit">-->
<!--                <template slot="icon">-->
<!--                  <i class="fa fa-search"></i>-->
<!--                </template>-->
<!--                Rechercher-->
<!--              </c-button-spinner>-->
<!--            </b-row>-->
<!--          </d-card-body>-->
<!--        </d-card>-->
<!--      </b-collapse>-->
<!--    </div>-->

    <d-card class="card-small">
      <d-card-body class="py-5">
<!--        <c-table :fetching="fetchingData" :table-data="filteredData" :fields="fields" :actions="actions" :per-page="50">-->
<!--          <p class="text-center" slot="empty">Aucun virement trouvé.</p>-->
<!--        </c-table>-->

        <p class="text-danger text-center" style="font-size: 200px">
          <i class="fa fa-ban"></i>
        </p>

        <h6 class="text-center">
          Cette fonctionnalité nécessite la connexion à un Système d'Information Bancaire (SIB)...
        </h6>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import {Api, formatAmount, Regex, Toast} from "@/helpers"

export default {
  title: "Virements bancaires automatiques",
  data() {
    return {
      search: '',
      fetchingSearch: false,
      startDate: "",
      endDate: "",
      searchStatus: null,

      fetchingData: false,
      data: [],

      //table header
      fields: [
        {key: 'recipient', label: 'Bénéficiare', sortable: true},
        {key: 'service_name', label: 'Service', sortable: true},
        {key: 'amount_pretty', label: 'Montant', sortable: true},
        {key: 'income', label: 'Gain', sortable: true},
        {key: 'status', label: 'Statut', sortable: true},
        {key: 'created_at_pretty', label: 'Initié le', sortable: true},
        {key: 'actions', label: 'Actions'},
      ],

      actions: [
        {type: 'white', icon: 'fa fa-ellipsis-h', title: "Détails du virement", handler: this.onItemSelect}
      ],

      modalVisible: false,

      selectedItem: null,

      status_options: [],
      status: null,
      update_balance: true,
      message: '',
      attachment_file: '',

      submitted: false,
      fetchingFormSubmit: false,
    }
  },
  computed: {
    filteredData() {
      const search = this.search.toLowerCase()
      return this.data.filter(item => {
        const bank_account = item.bank_account
        const bank = bank_account.bank
        const country = bank.country
        return (!this.searchStatus || this.searchStatus === item.transfer_status)
          && (
            item.service.name.toLowerCase().includes(search)
            || bank_account.name.toLowerCase().includes(search)
            || bank_account.account_number.toLowerCase().includes(search)
            || bank.slug.toLowerCase().includes(search)
            || bank.name.toLowerCase().includes(search)
            || country.slug.toLowerCase().includes(search)
            || country.country_name.toLowerCase().includes(search)
          )
      })
    },
    itemSelected() {
      return !!this.selectedItem
    },
    is_editable() {
      return this.auth.isAdmin()
    },
    status_fr() {
      return this.itemSelected ? this.selectedItem.status_fr : ''
    },
    badge() {
      return this.itemSelected ? this.selectedItem.badge : ''
    },
    created_at() {
      return this.itemSelected ? this.selectedItem.created_at : ''
    },
    updated_at() {
      return this.itemSelected ? this.selectedItem.updated_at : ''
    },
    reason() {
      return this.itemSelected ? this.selectedItem.reason : ''
    },
    has_attachment() {
      return this.itemSelected ? !!this.selectedItem.attachment : false
    },
    attachment() {
      return this.itemSelected
        ? this.selectedItem.attachment
          ? this.selectedItem.attachment : '-- Aucune pièce jointe --'
        : ''
    },
    bank() {
      return this.itemSelected ? this.selectedItem.bank_account.bank.name : ''
    },
    recipient() {
      return this.itemSelected ? this.selectedItem.bank_account.name : ''
    },
    recipient_account() {
      if (this.itemSelected) {
        const account = this.selectedItem.bank_account
        const bank = account.bank

        return `${bank.country.slug}${account.iban_key} ${bank.code}-${account.branch_code}-${account.account_number}-${account.rib_key}`
      }

      return ''
    },
    rib_file() {
      return this.itemSelected ? this.selectedItem.bank_account.rib_file : ''
    },
    rib_filename() {
      return this.itemSelected ? this.selectedItem.bank_account.rib_filename : ''
    },
    amount() {
      return this.itemSelected ? this.selectedItem.amount : ''
    },
    fees() {
      return this.itemSelected ? this.selectedItem.fees : ''
    },
    income() {
      return this.itemSelected ? this.selectedItem.income : ''
    },
    status_state() {
      return !this.submitted || !!this.status
    },
    message_state() {
      return !this.submitted || this.status !== 'REJECTED' || Regex.isNotBlank(this.message)
    },
  },
  created() {
    this.fetchingData = true

    Api.get('/bank/transfer/states')
      .then(res => this.status_options = res.data.bank_transfer_states)
      .catch(err => this.error = err)
      .then(() => null)

    Api.get('/bank/transfer/list')
      .then(res => {
        const data = res.data.bank_transfers
        if (data)
          this.data = data.map(this.mapItem)
        else
          Toast.info("Aucun virement trouvé")
      })
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },
  methods: {
    mapItem(item) {
      return {
        ...item,
        recipient: item.bank_account.name + `\n(${item.bank_account.bank.name})`,
        service_name: item.service.name,
        amount_pretty: formatAmount(item.amount),
        transfer_status: item.status,
        status: item.status_fr,
        statusVariant: item.badge,
        created_at_pretty: item.created_at.replace(' ', '\n')
      }
    },
    onItemSelect(item) {
      this.selectedItem = item
      this.modalVisible = true
      this.message = item.message
    },
    clearFields() {
      this.status = null
      this.update_balance = true
      this.message = ''
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.modalVisible = false
      this.clearFields()
    },
    isFormValid() {
      return this.status && (this.status !== 'REJECTED' || Regex.isNotBlank(this.message))
    },
    onFormSubmit() {
      this.submitted = true
      if (!this.isFormValid()) return

      const description = `virement de ${formatAmount(this.selectedItem.amount)} XAF vers ${this.selectedItem.bank_account.name}`
      const ans = prompt(`Veuillez saisir "${this.status}" pour changer le statut du ${description}.`)
      if (ans !== this.status) return

      this.fetchingFormSubmit = true
      Api.postFormData('/bank/transfer/change_status', {
        bank_transfer_id: this.selectedItem.id,
        status: this.status,
        update_balance: this.update_balance,
        message: this.message,
        attachment: this.attachment_file,
      })
        .then(res => {
          const bank_transfer = this.mapItem(res.data.bank_transfer)
          this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, bank_transfer)

          this.onModalClose()

          Toast.success(`Le statut du ${description} a été mis à jour avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },

    onSearchSubmit() {
      this.data = []
      this.fetchingSearch = true
      Api.get('/bank/transfer/find', {
        search: this.search,
        start_date: this.startDate,
        end_date: this.endDate,
        status: this.searchStatus
      })
        .then((res) => {
          const data = res.data.bank_transfers
          if (data)
            this.data = data.map(this.mapItem)
          else
            Toast.info("Aucun virement trouvé")
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingSearch = false)
    },
  }
}
</script>
